<template>
  <!-- 二段式 -->
   <div class="deferredExchange-content">
      <div class="breadcrumb">
        <breadcrumb urlName="Deferred Exchange" @goBack="goBack"></breadcrumb>
      </div>
      <div class="deferredExchange">
        <!-- <p class="title">Deferred Exchange</p> -->
        <img :src="isMaxScreen ? image : image1" alt="">
      </div>
   </div>
 </template>
 
 <script>
 import { mapState } from 'vuex';
 import breadcrumb from '../components/breadcrumb/breadcrumb.vue'
 export default {
   name: 'deferredExchange',
   components: {
    breadcrumb
   },
   data () {
     return {
      // image: require('../assets/image/home/de-pc.png'),
      // image1: require('../assets/image/home/de.png'),
      image: require('../assets/image/home/de_pc.png'),
      image1: require('../assets/image/home/de_h5.png'),
     };
   },
   props: {
   },
   computed: {
     ...mapState({
       isMaxScreen: state => state.isMaxScreen
     })
   },
   methods: {
    goBack(){
      this.$router.push('/home');
    }
   }
 };
 </script>
 
 <style lang="less" scoped>
    @media (max-width: 980px) {

      .deferredExchange-content{
        margin-bottom: 100px;
      }
      .breadcrumb{
        width: 700px;
        margin: 0 auto;
        height: 50px;
        line-height: 50px;
      }
      .title{
        color: #111;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 48px 0;
      }
      .deferredExchange{
        margin: 0 auto;
        background-color: #fff;
        width: 700px;
        img{
          width: 522px;
          margin-bottom: 48px;
        }
      }
    }

    @media (min-width: 981px) {
      .breadcrumb{
        margin: 24px 0;
      }
      .deferredExchange-content{
        width: 1200px;
        margin: 0 auto 25px;
      }
      .title{
        color: #111;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 48px 0;
      }
      .deferredExchange{
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
        img{
          width: 1020px;
          margin-bottom: 48px;
        }
      }
    }
 </style>
 